import colorHelpers from './color';
import presentHelpers from './present'
import monitorsHelpers from './monitors'

export default ({ moment }) => {
  return {
    color: colorHelpers(),
    present: presentHelpers({ moment }),
    monitors: monitorsHelpers({ moment })
  }
}